import React from 'react';
import Vacancy from './Vacancy';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import usePortalService from '../../services/PortalService';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { ManagerNavbar } from '../../Components/Navbars';
import { Vacancy as VacancyType } from '../../types';

let vacancyId = 0;
export const VacancyEmployer = () => {
    const navigate = useNavigate();

    const { getVacancyById, changeStatusVacancy } = usePortalService();

    const params = useParams();
    vacancyId = Number(params.id);
    const [vacancy, setVacancy] = useState<VacancyType>();
    const [error, setError] = useState();

    const toPublish = async () => {
        const result = await changeStatusVacancy({
            vacancyId,
            newStatus:0
        });
        if (result.success) {
            setVacancy ({
                ...vacancy as VacancyType,
                status:"Опубликована"
            })
        }
    }

    console.log(vacancy)

    const toArchive = async () => {
        const result = await changeStatusVacancy({
            vacancyId,
            newStatus:2
        });
        if (result.success) {
            setVacancy({
                ...vacancy as VacancyType,
                status:"В архиве"
            })
        }
    }

    useEffect(() => {
        getVacancyById(vacancyId)  
        .then(result => {
            if (result.success){
                setVacancy(result.vacancy)
            } else {
                setError(result.errors)
            }
        });
    }, []);

    if (vacancy) {
        return (
            <>
                <ManagerNavbar />
                {vacancy && <Vacancy vacancy={vacancy} userRole={"employer"}/>}
                {(vacancy.isEditable) && <footer>
                    <div style={{width:'100%', marginLeft:'6%', paddingTop: '16px'}}>
                        {(vacancy.status ==="Черновик" || vacancy.status ==="В архиве") && <Button type="primary" style={{marginRight:'16px'}} onClick={toPublish}> Опубликовать </Button>}
                        <Button style={{marginRight:'16px'}} onClick={() => navigate("/createVacancy/"+vacancyId)}> Редактировать </Button>
                        {(vacancy.status ==="Опубликована") && <Button danger onClick={toArchive}> В архив </Button>}
                    </div>
                </footer>}
            </>
        );
    } else {
        return (
            <>
                <ManagerNavbar />
                <p style={{paddingTop:'100px', paddingLeft: '150px'}}> {error} </p>
            </>
        )
    }
}